export default {
  data: () => ({
    userUtilsInterval: 1000,
    userUtilsCount: 100,
    userUtilsTimeId: null
  }),

  methods: {
    userUtilsCountdown (callback) {
      if (this.userUtilsCount > 0) {
        this.userUtilsTimeId = setTimeout(() => {
          this.userUtilsCount--
          this.userUtilsCountdown(callback)
        }, this.userUtilsInterval)
      } else {
        callback && callback()
      }
    },

    userUtilsStopCount () {
      this.userUtilsTimeId = null
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/userUtils.js